export const redirectToGetStarted = () => {
    const { pathname, search, hash } = window.location;
    const destination = pathname + search + hash;

    window.location.href = `${process.env.REACT_APP_NEXT_URL}/get-started?destination=${encodeURIComponent(destination)}`;
};
